export enum RejectionReasonsEnum {
    BLACK_DOTES = 'BLACK DOTS',
}